export default __webpack_public_path__ + "static/media/card.053f13fc.png";